import { autoRegisterFeature } from '@store/features/factory';

import { jotdocsFeature } from './store/feature';

autoRegisterFeature(jotdocsFeature);

export { default as JotDocNoteSectionView } from './components/jot-doc-note-section-view';
export { default as JotDocSection } from './components/jot-doc-section';
export * from './hooks/useJotdocSections';
export * from './hooks/useStreamingSections';
export * from './store';
export * from './types';
export * from './utils/jotdoc-copy';
export * from './utils/jotdoc-save';
export * from './utils/markdown-utils';
